
export type UpdateUser404 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
